module.exports = __webpack_public_path__ + "static/media/RAI.3a7aa540.png";